import { Injectable } from '@angular/core';

import { FIREFOX_STORAGE_QUOTA_EXCEEDED_NAME, STORAGE_QUOTA_EXCEEDED_NAME } from '../../constants/craig.constants';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    constructor(private readonly _window: Window) {}

    setRawItem(key: string, value: string): void {
        this._window.localStorage.setItem(key, value);
    }

    setParsedItem<T>(key: string, value: T): void {
        this._window.localStorage.setItem(key, JSON.stringify(value));
    }

    getRawItem(key: string): string | null {
        return this._window.localStorage.getItem(key);
    }

    getAllKeys(): string[] {
        return Object.keys(this._window.localStorage);
    }

    getParsedItem<T>(key: string): T | null {
        const item: string | null = this.getRawItem(key);

        try {
            return item ? JSON.parse(item) : null;
        } catch {
            return null;
        }
    }

    removeItem(key: string): void {
        this._window.localStorage.removeItem(key);
    }

    clear(): void {
        this._window.localStorage.clear();
    }

    isStorageExceededError(error: any): boolean {
        return (
            error instanceof DOMException &&
            (error.name === STORAGE_QUOTA_EXCEEDED_NAME || error.name === FIREFOX_STORAGE_QUOTA_EXCEEDED_NAME)
        );
    }
}
